import { useEffect, useMemo } from 'react'

import { useIntercom } from 'react-use-intercom'

import { capitalizeFirstLetter } from 'src/Helpers/layoutHelpers'
import { useAppSelector } from 'src/Hooks/redux'
import { getIsAuth } from 'src/Redux/auth-process/credentialsSlice/selectors'
import {
  getUser,
  getUserIntercomHash,
} from 'src/Redux/auth-process/userSlice/selectors'

export const useSetupIntercom = (): void => {
  const { boot } = useIntercom()
  const isAuth = useAppSelector(getIsAuth)
  const { email, first_name } = useAppSelector(getUser)
  const intercomHash = useAppSelector(getUserIntercomHash)

  const greetingName = useMemo(
    () => capitalizeFirstLetter(first_name || 'there'),
    [first_name],
  )

  useEffect(() => {
    if (isAuth && intercomHash) {
      boot({
        email,
        name: greetingName,
        userHash: intercomHash,
      })
    }
  }, [boot, greetingName, isAuth, email, intercomHash])
}
